import React, { useState, useEffect } from 'react';
import { Input, Button, message } from 'antd';
import { CheckOutlined } from '@ant-design/icons';  // Using the outline tick icon

const EditableTableCell = ({
  title,
  editable,
  children,
  record,
  handleSave,
  handleEdit,
  setEditingKey,
  editingKey,  // Pass in editingKey to determine if the row is being edited
  ...restProps
}) => {
  const [editingValue, setEditingValue] = useState(record.broker_percentage || '');
  console.log("title",title)
  useEffect(() => {
    if (editable) {
      setEditingValue(record.broker_percentage); 
    }
  }, [editable, record]);

  const handleClick = () => {
    const value = parseFloat(editingValue);
    if (isNaN(value)) {
      message.error('Please enter a valid number.');
      return;
    }
    if (value < 0 || value > 100) {
      message.error('Broker percentage must be between 0 and 100.');
      return;
    }

    handleSave(record.key, record, editingValue); 
    setEditingKey(''); // Reset editing key after saving
  };

  return (
    <td {...restProps}>
      {editable ? (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {console.log("record",record.key,record)}
          <Input
            type={title=="broker_percentage" ? "number" : ""}
            value={editingValue}
            onChange={(e) => setEditingValue(e.target.value)}
            onPressEnter={handleClick}
            style={{ fontSize:'0.8vw',padding: '0.3vw', borderRadius: '4px' }} // Adjust padding and borderRadius
          />
          <Button
            type="primary"  // Green filled button
            icon={<CheckOutlined style={{ fontSize: '16px' }} />}  // Outline tick icon
            onClick={handleClick}
            style={{ display:'flex', justifyContent:'center', alignItems:'center',backgroundColor:'green' ,padding: '5px 10px', marginLeft: '5px' }}  // Add padding and margin for better styling
          />
        </div>
      ) : (
        <div>
          {children}
          {/* Show Edit button only if this row is not being edited */}
          {editingKey !== record.key && record.editable && (
            <Button type="link" size="small" onClick={() => handleEdit(record.key)} style={{ marginLeft: 5 }}>
              Edit
            </Button>
          )}
        </div>
      )}
    </td>
  );
};

export default EditableTableCell;
